import React, { useEffect, useState } from "react";
import { DatePicker } from "antd";
import TableWithSkeleton from "../../../../components/table/TableWithSkeleton";
import closeTradeColumns from "../../../../columns/closeTradeColumns.jsx";
import toast from "react-hot-toast";
import { GetMTFCloseTradesApi } from "../../../../api/request/account.js";
import MyPagination from "../../../../components/pagination/Pagination";
// import dayjs from "dayjs";

const { RangePicker } = DatePicker;

const CloseTrades = ({ loginId }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [dates, setDates] = useState([]);

  const fetchClosedTrades = async () => {
    try {
      setLoading(true);

      const fromDate = dates?.[0]?.format("MM-DD-YYYY") || "";
      const toDate = dates?.[1]?.format("MM-DD-YYYY") || "";

      const queryParams = new URLSearchParams({
        PageNumber: page,
        PageSize: pageSize,
        SearchText: "",
        ApplyPagination: true,
        FromDate: fromDate,
        ToDate: toDate,
      }).toString();

      const response = await GetMTFCloseTradesApi(loginId, queryParams);

      if (response.data.success) {
        const formatted = response.data.data.map((item) => ({
          ...item,
          close: null,
        }));
        setData(formatted);
        setTotalRecords(response.data.totalRecords || 0);
      } else {
        toast.error(response.data.message || "Failed to fetch data");
      }
    } catch (error) {
      toast.error(error?.response?.data?.error?.message || "API Error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (loginId) {
      fetchClosedTrades();
    }
  }, [loginId, page, pageSize, dates]);

  return (
    <>
      <div className="flex justify-end mb-4">
        <RangePicker
          format="DD-MM-YYYY"
          className="py-1.5 rounded-lg"
          onChange={(val) => setDates(val || [])}
          disabledDate={(current) => current && current > new Date()}
        />
      </div>

      <div className="border border-gray-200 rounded-xl">
        <TableWithSkeleton
          columns={closeTradeColumns(page, pageSize)}
          data={data}
          loading={loading}
          index={true}
        />
      </div>
      <div className="mb-4">
        <MyPagination
          total={totalRecords}
          page={page}
          setPage={setPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
        />
      </div>
    </>
  );
};

export default CloseTrades;
